import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import ManagePurchaseView from "../components/manage-purchase/ManagePurchaseView";

const ManagePurchase = () => {
  return (
    <AdminLayout>
      <ManagePurchaseView />
    </AdminLayout>
  );
};

export default ManagePurchase;
